<script setup lang="ts">
/**
 * For audio, if we have the presigned url, we should just view that,
 * as that is the fastest way to get the file bytes. The file will be
 * downloaded in the background anyway. If the file is cached, then
 * we will never fetch the presigned url at all.
 * 
 * TODO: The audio player has weird text in the controls, I believe
 * due to the font variation settings.
 */

const props = defineProps({
  file: null
})
const { file } = toRefs(props)
const { rendererState } = useRenderer({ file })
</script>

<template>
  <div class="renderer-container">
    <audio
      v-if="rendererState.presignedUrl"
      controls
      :src="rendererState.presignedUrl"
      class="audio-content"
    />
    <audio
      v-else-if="rendererState.objectUrl"
      controls
      :src="rendererState.objectUrl"
      class="audio-content"
    />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.renderer-container
  @apply h-full w-full flex items-center justify-center

.audio-content
  @apply
</style>
